<template>
  <div v-if="visible" class="banner_height">
    <div id="searchBar" :class="searchBarFixed == true ? 'ondown_banner' :'down_banner'">
      <div class="left_close">
        <a class="down_close" @click="goClose" />
        <img src="https://static.mingchu.co/webapp/index2024/newLogo.png" alt="" class="down_himg">
      </div>
      <a v-if="des == ''" class="download" @click="goDown">{{ $tm('topHeader.buttonText') }}</a>
      <a v-else class="download 1" @click="goDownDes">{{ $tm('topHeader.buttonText') }}</a>
      <GCDOWN :down-show="DownShow" @showDwon="getshowDonw" />
      <GCGUIDE :down-show="guideInfo.weiXin" :img-type="$tm('topHeader.shareImg')" @showDwon="getWechat" />
      <!-- guideInfo.weiXin -->
    </div>
  </div>
</template>
<script>
import utils from '@/utils/utils'
import config from '@/config/config'
import GCDOWN from '@/components/gc-down'
import GCGUIDE from '@/components/gc-guide'
// import { superLink } from '@/utils/index'
export default {
  components: {
    GCDOWN,
    GCGUIDE
  },
  props: {
    isShow: {
      type: Boolean,
      default: true
    },
    link: {
      type: String,
      default: ''
    },
    webappLink: {
      type: String,
      default: ''
    },
    des: {
      type: String,
      default: ''
    },
    param: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      visible: this.isShow,
      weiXin: false,
      searchBarFixed: false,
      DownShow: false,
      guideInfo: {
        weiXin: false
      },
      parentData: {}
    }
  },
  created() {
    this.parentData = this.$route.query
  },

  mounted() {
    if (this.isShow) {
      window.addEventListener('scroll', this.handleScroll)
    }
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    goDownDes() {
      const self = this
      const u = navigator.userAgent
      const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
      if (utils.isGteatChefbrowser()) {
        // callback() // 如果是app内执行回调
      } else {
        if (utils.is_weixn()) {
          if (!isAndroid) { // !isAndroid
            utils.goDown(self.des, `${config.webapplink}${self.webappLink}`, self.param)
          } else {
            this.guideInfo.weiXin = true
          }
        } else {
          utils.goDown(self.des, `${config.webapplink}${self.webappLink}`, self.param)
        }
      }
    },
    goDown() {
      const self = this
      const u = navigator.userAgent
      const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
      if (utils.isGteatChefbrowser()) {
        // callback() // 如果是app内执行回调
      } else {
        if (utils.is_weixn()) {
          if (!isAndroid) { // !isAndroid
            utils.goDown('H5', `${config.webapplink}${self.webappLink}`)
          } else {
            this.guideInfo.weiXin = true
          }
        } else {
          utils.goDown('H5', `${config.webapplink}${self.webappLink}`)
        }
      }
    },
    handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      const offsetTop = document.querySelector('#searchBar') ? document.querySelector('#searchBar').offsetTop : 0
      if (scrollTop > offsetTop) {
        this.searchBarFixed = true
      } else {
        this.searchBarFixed = false
      }
    },
    goClose() {
      this.visible = false
    },
    getshowDonw(val) {
      this.DownShow = false
    },
    getWechat(val) {
      this.guideInfo.weiXin = false
    }
  }
}
</script>
